(ns rothko.theme.manatee.editor.document
  (:refer-clojure :exclude [rem])
  (:require [garden.units :refer [rem px]]))

(def common
  {:padding [[(rem 1) (rem 0.5)]]
   :margin [[(rem 1) 0 0]]
   :overflow :auto})

(def main
  {:est-transcription-annotator common
   :est-error-annotator common
   :script-annotator common
   :mwe-annotator common})
